// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row-2 {
	display: flex;
	flex-direction: column;
	align-content: center;
	margin: 1rem;
	justify-content: center;
}

.row-2.content {
	display: flex;
	flex-direction: column;
	margin: 1rem;
	justify-content: center;
	margin: 0rem 0rem;
}
.row2.reverse {
	flex-direction: row-reverse;
}
.row-2.image {
	flex-grow: 1;
	flex-shrink: 1;
	justify-self: center;
	align-self: center;
}

.row-2.image img {
	width: 100%;
	float: unset;
	justify-self: center;
	align-self: center;
	object-fit: contain;
	border-radius: 12px;
}

/* .wide {
	display: flex;
	flex-direction: column;
	flex-basis: 300px;
	flex-grow: 0;
	font-size: 1.2rem;
	justify-self: center;
	align-self: center;
} */
.wide-reverse {
	flex-direction: column-reverse;
	flex-basis: 300px;
	flex-grow: 0;
	font-size: 1.2rem;
	margin: 1rem;
}

.row-2.image.wide img {
	object-fit: contain;
	max-width: 30rem;
	flex-wrap: wrap;
	border-radius: 12px;
}

.row-2.image.rotate img {
	animation: rotate-layover 120s infinite linear;
}
.row-2.image.landscape img {
	rotate: 0deg;
}

.contrib {
	display: flex;
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
	margin-bottom: 1rem;
}
.contrib .logos {
	width: 80%;
	max-width: 250px;
	margin: 0rem 0rem 0rem 2rem;
	float: right;
}
.contrib .logos img {
	width: 100%;
}

.pins {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-content: center;
	justify-content: space-evenly;
	margin-bottom: 2rem;
}
.pins img {
	border-radius: 20rem;
	box-shadow: 0px 0px 6px 0px black;
	max-width: 150px;
	margin: 1rem;
}

.content strong {
	font-family: "Inter-Bold", sans-serif;
	font-weight: bold;
}

/* .row-2.content h4 {
  font-size: 3rem;
  padding: 1rem 0rem;
  line-height: 3.2rem;
  text-align: center;
} */

/* .row-2.content h5 {
  font-size: 2rem;
  padding: 1rem 0rem;
  line-height: 2.8rem;
  text-align: center;
} */

/* .row-2.content h6 {
  font-size: 1.8rem;
  padding: 0rem;
  margin-bottom: 2rem;
  line-height: 2.2rem;
  text-align: justify;
} */

/* .row-2.content p {
  font-size: 1.4rem;
  text-align: justify;
  padding: 0rem;
  margin-bottom: 2rem;
  line-height: 2rem;
} */

.quote {
	margin-bottom: 2rem;
	color: var(--secondary-color1);
}

.emph {
	font-style: italic;
}

@media (min-width: 500px) {
	.row-2 {
		display: flex;
		flex-direction: row;
		align-items: center;
		flex-grow: 0;
		flex-shrink: 1;
		margin: 1rem;
		flex-wrap: wrap;
		flex-basis: content;
	}
	.wide-reverse {
		display: flex;
		flex-direction: column-reverse;
		flex-grow: 0;
	}
	.image.wide {
		flex-direction: column;
		flex-grow: 0;
		align-content: space-around;
		flex-basis: unset;
	}
	.row-2.content {
		justify-content: flex-start;
		margin: 1rem 1rem;
		align-items: center;
		flex-basis: content;
		flex-shrink: 2;
	}
	.row-2.content p {
		font-size: 1.62vw;
		text-align: justify;
		padding: 0rem;
		margin-bottom: 2rem;
		line-height: 2.5vw;
	}
	.content strong {
		font-family: "Inter-Bold", sans-serif;
		font-weight: bold;
	}

	.content h6 {
		font-size: 1.8vw;
		padding: 0rem;
		margin: 0rem;
		margin-bottom: 2rem;
		line-height: 2.6vw;
		text-align: center;
	}
	.row-2.content h5 {
		font-size: 2.5vw;
		padding: 1rem 0rem;
		line-height: 2.8vw;
	}

	.row-2.content h4 {
		font-size: 3vw;
		padding: 1rem 0rem;
		line-height: 3.2vw;
	}

	.row-2.image {
		padding: 0rem;
		margin: 1rem;
		flex-basis: 300px;
		/* flex-shrink: 1; */
	}
	.reverse {
		align-items: center;
		flex-direction: row-reverse;
	}

	.row-2.content h3 {
		padding: 1rem 0rem;
	}
	.row-2.image.landscape img {
		rotate: 0deg;
	}

	.row-2.image.wide img {
		width: 300px;
	}
}
/*@media (min-width: 500px) and (max-width: 1000px) {
 .row-2.content {

  }
  .row-2.image {
    padding: 0rem;
    margin: 1rem;
    max-width: 400px;

  
  }
} */
@media (min-width: 1000px) {
	.row-2.image {
		max-width: 400px;
	}

	.row-2.content p {
		font-size: 1.6rem;
		text-align: justify;
		padding: 0rem;
		margin-bottom: 2rem;
		line-height: 2.5rem;
	}
	.row-2.content strong {
		font-family: "Inter-Bold", sans-serif;
		font-weight: bold;
	}

	.row-2.content h6 {
		font-size: 1.8rem;
		padding: 0rem;
		/* margin: 0rem 1rem; */
		line-height: 2.6rem;
		text-align: center;
	}
	.row-2.content h5 {
		font-size: 2.5rem;
		padding: 1rem 0rem;
		line-height: 2.8rem;
	}

	.row-2.content h4 {
		font-size: 3rem;
		padding: 1rem 0rem;
		line-height: 3.2rem;
	}

	.contrib {
		display: inline-block;
		width: 100%;
	}
}
`, "",{"version":3,"sources":["webpack://./src/pages/GenericPage/PageRows/pageRows.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;CACtB,qBAAqB;CACrB,YAAY;CACZ,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,YAAY;CACZ,uBAAuB;CACvB,iBAAiB;AAClB;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,YAAY;CACZ,cAAc;CACd,oBAAoB;CACpB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,oBAAoB;CACpB,kBAAkB;CAClB,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;;;;;;;;GAQG;AACH;CACC,8BAA8B;CAC9B,iBAAiB;CACjB,YAAY;CACZ,iBAAiB;CACjB,YAAY;AACb;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,8CAA8C;AAC/C;AACA;CACC,YAAY;AACb;;AAEA;CACC,aAAa;IACV,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,6BAA6B;CAChC,mBAAmB;AACpB;AACA;CACC,UAAU;CACV,gBAAgB;CAChB,2BAA2B;CAC3B,YAAY;AACb;AACA;CACC,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,qBAAqB;CACrB,6BAA6B;CAC7B,mBAAmB;AACpB;AACA;CACC,oBAAoB;CACpB,iCAAiC;CACjC,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,qCAAqC;CACrC,iBAAiB;AAClB;;AAEA;;;;;GAKG;;AAEH;;;;;GAKG;;AAEH;;;;;;GAMG;;AAEH;;;;;;GAMG;;AAEH;CACC,mBAAmB;CACnB,8BAA8B;AAC/B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC;EACC,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,eAAe;EACf,mBAAmB;CACpB;CACA;EACC,aAAa;EACb,8BAA8B;EAC9B,YAAY;CACb;CACA;EACC,sBAAsB;EACtB,YAAY;EACZ,2BAA2B;EAC3B,iBAAiB;CAClB;CACA;EACC,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;CACf;CACA;EACC,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;CACnB;CACA;EACC,qCAAqC;EACrC,iBAAiB;CAClB;;CAEA;EACC,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;CACnB;CACA;EACC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,cAAc;EACd,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;CACrB;CACA;EACC,mBAAmB;EACnB,2BAA2B;CAC5B;;CAEA;EACC,kBAAkB;CACnB;CACA;EACC,YAAY;CACb;;CAEA;EACC,YAAY;CACb;AACD;AACA;;;;;;;;;;;GAWG;AACH;CACC;EACC,gBAAgB;CACjB;;CAEA;EACC,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;CACpB;CACA;EACC,qCAAqC;EACrC,iBAAiB;CAClB;;CAEA;EACC,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;CACnB;CACA;EACC,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;CACpB;;CAEA;EACC,eAAe;EACf,kBAAkB;EAClB,mBAAmB;CACpB;;CAEA;EACC,qBAAqB;EACrB,WAAW;CACZ;AACD","sourcesContent":[".row-2 {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-content: center;\n\tmargin: 1rem;\n\tjustify-content: center;\n}\n\n.row-2.content {\n\tdisplay: flex;\n\tflex-direction: column;\n\tmargin: 1rem;\n\tjustify-content: center;\n\tmargin: 0rem 0rem;\n}\n.row2.reverse {\n\tflex-direction: row-reverse;\n}\n.row-2.image {\n\tflex-grow: 1;\n\tflex-shrink: 1;\n\tjustify-self: center;\n\talign-self: center;\n}\n\n.row-2.image img {\n\twidth: 100%;\n\tfloat: unset;\n\tjustify-self: center;\n\talign-self: center;\n\tobject-fit: contain;\n\tborder-radius: 12px;\n}\n\n/* .wide {\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex-basis: 300px;\n\tflex-grow: 0;\n\tfont-size: 1.2rem;\n\tjustify-self: center;\n\talign-self: center;\n} */\n.wide-reverse {\n\tflex-direction: column-reverse;\n\tflex-basis: 300px;\n\tflex-grow: 0;\n\tfont-size: 1.2rem;\n\tmargin: 1rem;\n}\n\n.row-2.image.wide img {\n\tobject-fit: contain;\n\tmax-width: 30rem;\n\tflex-wrap: wrap;\n\tborder-radius: 12px;\n}\n\n.row-2.image.rotate img {\n\tanimation: rotate-layover 120s infinite linear;\n}\n.row-2.image.landscape img {\n\trotate: 0deg;\n}\n\n.contrib {\n\tdisplay: flex;\n    width: 100%;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-around;\n\tmargin-bottom: 1rem;\n}\n.contrib .logos {\n\twidth: 80%;\n\tmax-width: 250px;\n\tmargin: 0rem 0rem 0rem 2rem;\n\tfloat: right;\n}\n.contrib .logos img {\n\twidth: 100%;\n}\n\n.pins {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: wrap;\n\talign-content: center;\n\tjustify-content: space-evenly;\n\tmargin-bottom: 2rem;\n}\n.pins img {\n\tborder-radius: 20rem;\n\tbox-shadow: 0px 0px 6px 0px black;\n\tmax-width: 150px;\n\tmargin: 1rem;\n}\n\n.content strong {\n\tfont-family: \"Inter-Bold\", sans-serif;\n\tfont-weight: bold;\n}\n\n/* .row-2.content h4 {\n  font-size: 3rem;\n  padding: 1rem 0rem;\n  line-height: 3.2rem;\n  text-align: center;\n} */\n\n/* .row-2.content h5 {\n  font-size: 2rem;\n  padding: 1rem 0rem;\n  line-height: 2.8rem;\n  text-align: center;\n} */\n\n/* .row-2.content h6 {\n  font-size: 1.8rem;\n  padding: 0rem;\n  margin-bottom: 2rem;\n  line-height: 2.2rem;\n  text-align: justify;\n} */\n\n/* .row-2.content p {\n  font-size: 1.4rem;\n  text-align: justify;\n  padding: 0rem;\n  margin-bottom: 2rem;\n  line-height: 2rem;\n} */\n\n.quote {\n\tmargin-bottom: 2rem;\n\tcolor: var(--secondary-color1);\n}\n\n.emph {\n\tfont-style: italic;\n}\n\n@media (min-width: 500px) {\n\t.row-2 {\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\talign-items: center;\n\t\tflex-grow: 0;\n\t\tflex-shrink: 1;\n\t\tmargin: 1rem;\n\t\tflex-wrap: wrap;\n\t\tflex-basis: content;\n\t}\n\t.wide-reverse {\n\t\tdisplay: flex;\n\t\tflex-direction: column-reverse;\n\t\tflex-grow: 0;\n\t}\n\t.image.wide {\n\t\tflex-direction: column;\n\t\tflex-grow: 0;\n\t\talign-content: space-around;\n\t\tflex-basis: unset;\n\t}\n\t.row-2.content {\n\t\tjustify-content: flex-start;\n\t\tmargin: 1rem 1rem;\n\t\talign-items: center;\n\t\tflex-basis: content;\n\t\tflex-shrink: 2;\n\t}\n\t.row-2.content p {\n\t\tfont-size: 1.62vw;\n\t\ttext-align: justify;\n\t\tpadding: 0rem;\n\t\tmargin-bottom: 2rem;\n\t\tline-height: 2.5vw;\n\t}\n\t.content strong {\n\t\tfont-family: \"Inter-Bold\", sans-serif;\n\t\tfont-weight: bold;\n\t}\n\n\t.content h6 {\n\t\tfont-size: 1.8vw;\n\t\tpadding: 0rem;\n\t\tmargin: 0rem;\n\t\tmargin-bottom: 2rem;\n\t\tline-height: 2.6vw;\n\t\ttext-align: center;\n\t}\n\t.row-2.content h5 {\n\t\tfont-size: 2.5vw;\n\t\tpadding: 1rem 0rem;\n\t\tline-height: 2.8vw;\n\t}\n\n\t.row-2.content h4 {\n\t\tfont-size: 3vw;\n\t\tpadding: 1rem 0rem;\n\t\tline-height: 3.2vw;\n\t}\n\n\t.row-2.image {\n\t\tpadding: 0rem;\n\t\tmargin: 1rem;\n\t\tflex-basis: 300px;\n\t\t/* flex-shrink: 1; */\n\t}\n\t.reverse {\n\t\talign-items: center;\n\t\tflex-direction: row-reverse;\n\t}\n\n\t.row-2.content h3 {\n\t\tpadding: 1rem 0rem;\n\t}\n\t.row-2.image.landscape img {\n\t\trotate: 0deg;\n\t}\n\n\t.row-2.image.wide img {\n\t\twidth: 300px;\n\t}\n}\n/*@media (min-width: 500px) and (max-width: 1000px) {\n .row-2.content {\n\n  }\n  .row-2.image {\n    padding: 0rem;\n    margin: 1rem;\n    max-width: 400px;\n\n  \n  }\n} */\n@media (min-width: 1000px) {\n\t.row-2.image {\n\t\tmax-width: 400px;\n\t}\n\n\t.row-2.content p {\n\t\tfont-size: 1.6rem;\n\t\ttext-align: justify;\n\t\tpadding: 0rem;\n\t\tmargin-bottom: 2rem;\n\t\tline-height: 2.5rem;\n\t}\n\t.row-2.content strong {\n\t\tfont-family: \"Inter-Bold\", sans-serif;\n\t\tfont-weight: bold;\n\t}\n\n\t.row-2.content h6 {\n\t\tfont-size: 1.8rem;\n\t\tpadding: 0rem;\n\t\t/* margin: 0rem 1rem; */\n\t\tline-height: 2.6rem;\n\t\ttext-align: center;\n\t}\n\t.row-2.content h5 {\n\t\tfont-size: 2.5rem;\n\t\tpadding: 1rem 0rem;\n\t\tline-height: 2.8rem;\n\t}\n\n\t.row-2.content h4 {\n\t\tfont-size: 3rem;\n\t\tpadding: 1rem 0rem;\n\t\tline-height: 3.2rem;\n\t}\n\n\t.contrib {\n\t\tdisplay: inline-block;\n\t\twidth: 100%;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
